import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Field } from 'formik';
import { Row, Col, Button } from 'react-bootstrap';
import LocationInfo from '../../location/Location';
import ChangeLocation from '../../location/ChangeLocation';
import { Collapse } from 'react-bootstrap'; // Global Elements

import { FormSelect } from '../elements'; //ga tracker

import gaTracker from '../../../util/ga-analytics/gaTracker';
var options = [{
  'label': 'Party size',
  'value': ''
}, {
  'label': '1',
  'value': 1
}, {
  'label': '2',
  'value': 2
}, {
  'label': '3',
  'value': 3
}, {
  'label': '4',
  'value': 4
}, {
  'label': '5',
  'value': 5
}, {
  'label': '6',
  'value': 6
}];
export default (function (props) {
  var store = props.store,
      location = props.location,
      results = props.results,
      _changeHandler = props.changeHandler,
      partySize = props.partySize,
      setConfirmActive = props.setConfirmActive,
      storeId = props.storeId,
      waitlistId = props.waitlistId;

  var changeLocationHandler = function changeLocationHandler() {
    setOpen(!open);
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var active = storeId === waitlistId;

  var numberGuestClick = function numberGuestClick(info) {
    console.log({
      info: info
    });
    var data = {
      gtm: {
        uniqueEventId: '35',
        elementTarget: info.target.value
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Collapse, {
    in: !open
  }, /*#__PURE__*/React.createElement("div", {
    id: "cb-collapse-location"
  }, /*#__PURE__*/React.createElement(LocationInfo, {
    store: store,
    location: location,
    changeLocationHandler: changeLocationHandler
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement("div", {
    id: "cb-collapse-locations"
  }, /*#__PURE__*/React.createElement(ChangeLocation, {
    store: store,
    location: location,
    results: results,
    showCurrent: false,
    changeLocationHandler: changeLocationHandler,
    setStoreHandler: changeLocationHandler
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: partySize,
    name: "partySize",
    label: "Party Size",
    component: FormSelect,
    options: options,
    changeHandler: function changeHandler() {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      numberGuestClick(params[0]);

      _changeHandler.call.apply(_changeHandler, [this].concat(params));
    }
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, active && /*#__PURE__*/React.createElement("a", {
    className: "cb-color-red-800",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return setConfirmActive(true);
    }
  }, "Cancel Place On Wait List"))));
});